import * as React from 'react';
import { FC } from 'react';
import { IMedia, IProduct } from '../../../../../../types';
import ProductCarousel from '../ProductCarousel';

interface ProductContainerProps {
  products: IProduct[];
  parentMedia: IMedia;
  isSingleSection?: boolean;
  onAddToCart?: (product: IProduct, media: IMedia) => void;
}

const ProductModalContainer: FC<ProductContainerProps> = ({
  products,
  parentMedia,
  isSingleSection,
  onAddToCart,
}) => {
  return (
    <ProductCarousel
      products={products}
      parentMedia={parentMedia}
      isSingleSection={isSingleSection}
      onAddToCart={onAddToCart}
    />
  );
};

export default ProductModalContainer;
